import { Button, Spinner } from "@hulahoop/ui";
import type { ReactNode, UIEventHandler } from "react";
import type { CommentsLabels } from "@/domain/types/commentsLabels";

export function CommentsPanel({
  header,
  children,
  loading,
  error,
  empty,
  resolved,
  labels,
  onRetry,
  onScroll,
}: {
  header: ReactNode;
  children: ReactNode;
  loading: boolean;
  error: boolean;
  empty: boolean;
  resolved: boolean;
  labels: CommentsLabels;
  onRetry: () => void;
  onScroll?: UIEventHandler<HTMLDivElement>;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      {header}
      <div className="min-h-0 flex-1 overflow-y-auto py-1" onScroll={onScroll}>
        {loading && <Spinner label={labels.loading} />}
        {error && (
          <div role="alert" className="px-3 py-2">
            <p>{labels.error}</p>
            <Button variant="outline" size="sm" onClick={onRetry}>
              {labels.retry}
            </Button>
          </div>
        )}
        {!loading && !error && empty && (
          <p className="px-3 py-2 text-(length:--font-ui-sm) text-muted-foreground">
            {resolved ? labels.empty_resolved : labels.empty_open}
          </p>
        )}
        {children}
      </div>
    </div>
  );
}
